import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../../utils/axios";

export const fetchCards = createAsyncThunk(
  '/market/fetchCards',
  async ({ page }, { getState }) => {
    const cardsState = getState().cards.cards;

    const { data } = await axios.get(`/market`, {
      params: {
        status: cardsState.filter.status,
        size_to: cardsState.filter.size === '0' ? null : cardsState.filter.size,
        price_to: cardsState.filter.price === '0' ? null : cardsState.filter.price,
        cathegory: cardsState.filter.cathegory,
        limit: 44,
        page: page ?? cardsState.currentPage, // если page не передан — берём из state
      },
    });

    return data;
  }
);

export const fetchCardsSale = createAsyncThunk(
    '/market/fetchCardsSale',
    async (_, { getState }) => {
        const cardsState = getState().cards.cards;

        const { data } = await axios.get(`/market`, { params: {
          status: cardsState.filter.status,
          size_to: cardsState.filter.size === '0' ? null : cardsState.filter.size,
          price_to: cardsState.filter.price === '0' ? null : cardsState.filter.price,
          cathegory: cardsState.filter.cathegory,
          salepage: true,
          limit: 44,
          page: cardsState.currentPage,
        }});

        return data;
    }
);

export const fetchMyCards = createAsyncThunk(
    '/market/fetchMyCards',
    async (params, { getState }) => {
        const cardsState = getState().cards.cards;
        const { userId } = params;

        const { data } = await axios.get(`/market/cards/${userId}`, { params: {
          status: cardsState.filter.status,
          size_to: cardsState.filter.size === '0' ? null : cardsState.filter.size,
          price_to: cardsState.filter.price === '0' ? null : cardsState.filter.price,
          cathegory: cardsState.filter.cathegory,
          limit: 12,
          page: cardsState.currentPage,
        }});

        return data;
    }
);

const initialState = {
    cards: {
        items: [],
        status: 'loading',
        scrollPosition: null,
        pages: 1,
        currentPage: 1,
        limit: 4,
        filter: {
            cathegory: 'teddy',
            status: null,
            size: '0',
            price: '0',
        }
    },
}

const cardsSlice = createSlice({
    name: 'cards',
    initialState,
    reducers: {
        saveScrollPosition: (state, action) => {
            state.cards.scrollPosition = action.payload;
        },
        setFilterCathegory: (state, action) => {
            state.cards.filter.cathegory = action.payload
        },
        setFilterSize: (state, action) => {
            state.cards.filter.size = action.payload;
        },
        setFilterPrice: (state, action) => {
            state.cards.filter.price = action.payload;
        },
        setFilterStatus: (state, action) => {
            state.cards.filter.status = action.payload;
        },
        setPageSize: (state, action) => {
            state.cards.limit = action.payload;
        },
        setCurrentPage: (state, action) => {
            state.cards.currentPage = action.payload;
        },
    },
    extraReducers: {
        [fetchCards.pending] : (state) => {
            state.cards.status = 'loading';
        },
        
        [fetchCards.fulfilled] : (state, action) => {
            state.cards.items = action.payload.items;
            state.cards.pages = action.payload.pages;
            state.cards.status = 'loaded';
        },

        [fetchCardsSale.pending] : (state) => {
            state.cards.status = 'loading';
        },
        
        [fetchCardsSale.fulfilled] : (state, action) => {
            state.cards.items = action.payload.items;
            state.cards.pages = action.payload.pages;
            state.cards.status = 'loaded';
        },

        [fetchMyCards.pending] : (state) => {
            state.cards.status = 'loading';
        },
        
        [fetchMyCards.fulfilled] : (state, action) => {
            state.cards.items = action.payload.items;
            state.cards.pages = action.payload.pages;
            state.cards.status = 'loaded';
        },
    },
})

export const cardsSelect = (state) => state.cards.cards

export const cardsReducer = cardsSlice.reducer;

export const {
    setFilterCathegory,
    setFilterSize,
    setFilterPrice,
    setFilterStatus,

    saveScrollPosition,
    setPageSize, setCurrentPage,
} = cardsSlice.actions;
